import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Typography,
  TextField,
} from "@mui/material";

const cellSx = {
  backgroundColor: "rgba(47, 53, 71, 0.9)",
  border: "1.5px solid #fff",
  color: "white",
  padding: "10px 8px",
};

const numberSx = {
  ...cellSx,
  textAlign: "left",
  fontWeight: 600,
};

// Helper to format numbers with two decimals
const formatNum = (num) =>
  num.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const IPSResignationTable = ({
  declaredSalary = 0,
  nightBonus = 0,
  advanceDeduction = 0,
  ipsDeductions = 0,
  familyBonus = 0,
  total = 0,
  onValuesChange, // optional callback on edits
}) => {
  // Editable Advance Deduction state as string formatted to 2 decimals initially
  const [editableAdvanceDeduction, setEditableAdvanceDeduction] = useState(
    advanceDeduction.toFixed(2)
  );

  // Update local state if advanceDeduction prop changes
  useEffect(() => {
    setEditableAdvanceDeduction(Number(advanceDeduction).toFixed(2));
  }, [advanceDeduction]);

  // Handle advance deduction change with numeric and decimal validation
  const handleAdvanceDeductionChange = (event) => {
    const val = event.target.value;
    // Allow empty or valid decimal input
    if (val === "" || /^\d*\.?\d*$/.test(val)) {
      setEditableAdvanceDeduction(val);
      if (typeof onValuesChange === "function") {
        onValuesChange({ advanceDeduction: Number(val) || 0 });
      }
    }
  };

  // Dynamically recalculate total with the current editable advance deduction
  const recalculatedTotal =
    (Number(declaredSalary) || 0) +
    (Number(nightBonus) || 0) +
    (Number(familyBonus) || 0) -
    (Number(editableAdvanceDeduction) || 0) -
    (Number(ipsDeductions) || 0);

  const rows = [
    [
      "Salario Declarado (Mes)",
      formatNum(declaredSalary),
      "Declarado a IPS, durante el último mes",
    ],
    ["Adicional Nocturno", formatNum(nightBonus), "Si Corresponde"],
    ["Bonificacion Familiar", formatNum(familyBonus), "Para el último período, si corresponde"],
    [
      "Descuentos",
      <TextField
        value={editableAdvanceDeduction}
        onChange={handleAdvanceDeductionChange}
        variant="standard"
        inputProps={{
          style: { 
            color: "red", 
            padding: "6px 8px", fontWeight: 600 },
          inputMode: "decimal",
          autoComplete: "off",
          spellCheck: false,
          placeholder: "0.00",
        }}
        // sx={{
        //   "& .MuiInputBase-input": { textAlign: "left", color: "white" },
        //   width: "120px",
        // }}
        sx={{
      "& .MuiInputBase-input": { textAlign: "left", color: "red" }, // 👈 y aquí también
      width: "120px",
    }}
        
      />,
      "Anticipos, préstamos, etc.",
    ],
    [
      "IPS 9%",
      ipsDeductions ? `-${formatNum(ipsDeductions)}` : "-",
      "Del ultimo mes, si corresponde",
    ],
  ];

  return (
    <Box mt={4}>
      <Typography variant="h6" mb={2} fontWeight="bold" color="white">
        Renuncia - IPS
      </Typography>
      <TableContainer component={Paper} sx={{ background: "rgba(47, 53, 71, 0.9)" }}>
        <Table>
          <TableBody>
            {rows.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                <TableCell sx={cellSx}>{row[0]}</TableCell>
                <TableCell
                  sx={{
                    ...numberSx,
                    color:
                      row[0] === "IPS 9%"
                        ? "red"
                        : row[0].toLowerCase().includes("deduction")
                        ? "red"
                        : row[0] === "IPS Severance"
                        ? "#3afa60"
                        : "white",
                  }}
                >
                  {row[1]}
                </TableCell>
                <TableCell sx={cellSx}>{row[2]}</TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell sx={{ ...cellSx, fontWeight: 700 }}>Total a Pagar</TableCell>
              <TableCell
                colSpan={2}
                sx={{
                  ...numberSx,
                  background: "rgba(34,189,110,0.15)",
                  color: "#3afa60",
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: 20,
                }}
              >
                {formatNum(recalculatedTotal)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default IPSResignationTable;
